export default __webpack_public_path__ + "static/media/IMG_0518-10_tn.faf47a5f.jpg";